module.exports = __webpack_public_path__ + "img/arrow_left.0f0072e9.png";